import React from 'react';

import AppWrapper from 'components/apps/AppWrapper';
import BillingForm from 'components/settings/billing/BillingForm';

export default function BillingFormWrapper({ contextProps, wrappedProps }) {
  return (
    <AppWrapper {...contextProps}>
      <BillingForm {...wrappedProps} />
    </AppWrapper>
  );
}
